module.exports = __webpack_public_path__ + "media/images/sp/stores/kamakura/kamakura_concept_01-218a9c7f8004a623398e4a75bfccd9a9.jpg";